import { Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy, inject, output } from "@angular/core";
import { AlertService } from "src/service/alert.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { MqttConfigurationSchemaEntry } from "src/components/shared-components/interfaces/mqtt-configuration-schema-entry";
import { FormsModule } from "@angular/forms";
import { IonButton, IonIcon } from "@ionic/angular";

@Component({
    selector: "app-drag-and-drop-files",
    templateUrl: "./drag-and-drop-files.component.html",
    styleUrls: ["./drag-and-drop-files.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, IonButton, IonIcon, TranslatePipe]
})
export class DragAndDropFilesComponent implements OnInit {
  private readonly _alertController = inject(AlertService);
  private readonly _translateService = inject(TranslateService);

  public isDragover = false;
  public isUploading = false;
  public isUploaded = false;

  public fileUrl!: string | null;
  public uploadFile!: File | null;
  public allowedFileTypeDescription: string = "";

  @Input() allowedFileType: string = "";
  @Input() otherInstructions: string = "";
  readonly uploadedFileEvent = output<any>();
  readonly deleteFileEvent = output<void>();
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;

  public ngOnInit(): void {
    this.allowedFileTypeDescription = this.allowedFileType.split(",").join("/");
  }

  /** Change file on drop/click on button **/
  public onChangeUploadFile(event: Event): void {
    if (!this.isUploaded) {
      const file = (event.target as HTMLInputElement).files[0] as File;
      this.fileUrl = URL.createObjectURL(file);
      this.uploadFile = file;
    }
  }

  /** Upload file to server or read file (if format is xml/xlsx) **/
  public async onClickUploadFile(): Promise<void> {
    if (this.allowedFileType === ".xml") {
      let formData = new FormData();
      formData.append("file", this.uploadFile);
      this.uploadedFileEvent.emit(formData);
    } else if (this.allowedFileType === ".xlsx") {
      // if  file type === xlsx emit buffer to page
      const buffer = await this.readFileAs("Buffer");
      this.uploadedFileEvent.emit(buffer as Buffer);
    } else {
      this.uploadedFileEvent.emit(this.uploadFile);
    }

    this.isUploaded = true;
    //this.isUploading = true;
    //TODO: logica di upload
  }

  /** Set iSDragover on true for adding styling **/
  public onDragover(): void {
    if (!this.isUploaded) {
      this.isDragover = true;
    }
  }
  /** Set iSDragover on false for removing styling **/
  public onDragleave(): void {
    if (!this.isUploaded) {
      this.isDragover = false;
    }
  }

  /** Confirmation popup on click **/
  public async onClickpresentAlertConfirmDismiss(): Promise<void> {
    try {
      const result: boolean =
        await this._alertController.presentAlertConfirmOrDismiss(
          this._translateService.instant("dictionary.confirmDeleteFile"),
          "",
          ""
        );

      if (result) {
        this.deleteFile();
      }
    } catch { }
  }

  /**
 * Read uploaded file as buffer or text
 * @param type of reading to resolve (possible values: "Buffer", "Text")
 * @returns promise with file reader result
 */
  private readFileAs(type: "Buffer" | "Text"): Promise<unknown> {
    return new Promise((resolve) => {
      const fileReader = new FileReader()
      switch (type) {
        case "Buffer":
          fileReader.readAsArrayBuffer(this.uploadFile);
          break;
        default:
          fileReader.readAsText(this.uploadFile);
      }
      fileReader.onload = () => {
        resolve(fileReader.result)
      }
    })
  }

  /** Remove file on button click **/
  private deleteFile(): void {
    /* Resetting input, uploadFile and fileUrl */
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = null;
    }

    this.uploadFile = null;
    this.fileUrl = null;
    this.isUploaded = false;
    this.deleteFileEvent.emit();
  }
}